<template>
  <div class="print-forms-page">
    <h2 class="page-title">Скачивание печатных форм</h2>

    <el-card>
      <el-form label-position="top">
        <el-form-item label="Компания">
          <el-select
              v-model="selectedCompany"
              :disabled="disabled"
              placeholder="Выберите компанию"
              style="width: 100%"
              @change="onCompanyChange"
          >
            <el-option
                v-for="company in companies"
                :key="company.bin"
                :label="company.name"
                :value="company.station"
            />
          </el-select>
        </el-form-item>

        <el-form-item
            v-if="documents.length"
            label="Документ"
        >
          <div class="documents-grid">
            <div
                v-for="doc in documents"
                :key="doc.key"
                class="document-card"
                :class="{ active: selectedDocument && selectedDocument.key === doc.key }"
                @click="selectedDocument = doc"
            >
              <i class="el-icon-document"></i>
              <span>{{ doc.title }}</span>
            </div>
          </div>
        </el-form-item>

        <el-form-item
            v-if="selectedDocument"
            label="Формат файла"
        >
          <el-radio-group v-model="selectedFormat">
            <el-radio-button label="pdf">
              PDF
            </el-radio-button>

            <el-radio-button label="cms">
              CMS
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="Период">
          <el-date-picker
              v-model="period"
              type="daterange"
              unlink-panels
              range-separator="—"
              start-placeholder="Дата начала"
              end-placeholder="Дата окончания"
              value-format="yyyy-MM-dd"
              style="width: 100%"
          />
        </el-form-item>

        <div class="actions">
          <el-button
              type="primary"
              icon="el-icon-download"
              :disabled="!canDownload"
              :loading="loading"
              @click="download"
          >
            Скачать архив
          </el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getDocumentsList } from '@/modules/permissions/permissions'
import blockchainApi from '@/modules/api/blockchain'
import authorizationAPI from '@/modules/api/authorization'

export default {
  name: 'PrintFormsDownload',

  data () {
    return {
      loading: false,
      selectedCompany: null,
      selectedDocument: null,
      selectedFormat: 'pdf',
      disabled: false,
      period: [],
      documents: [],
      companies: [
        {
          name: 'ТОО "Ертыс-сервис"',
          station: 'ERTYS',
          bin: '1911400253455'
        },
        {
          name: 'ТОО "Казыкурт-ЮГ"',
          station: 'KAZYKURT',
          bin: '1911400253454'
        },
        {
          name: 'ТОО "Batys Petroleum"',
          station: 'BATYS',
          bin: '1911400253453'
        },
        {
          name: 'Вагонники',
          station: 'VAGONNIK',
          bin: '19114002534511'
        }
      ]
    }
  },

  computed: {
    canDownload () {
      return (
        this.selectedCompany &&
        this.selectedDocument &&
        this.period &&
        this.period.length === 2
      )
    }
  },
  mounted () {
    console.log('authorizationAPI.isRolePtc()', authorizationAPI.isRolePtc())

    if (this.isUserKazykurt() || this.isRoleErtys() || this.isRoleBatys() || this.isRoleVagonnik()) {
      this.disabled = true
      const bin = authorizationAPI.getUsersCompanyBin()
      this.selectedCompany = this.companies.filter(i => i.bin === bin)[0].station
      this.onCompanyChange(this.selectedCompany)
    }
  },
  methods: {
    isRolePtc () {
      return authorizationAPI.isRolePtc()
    },
    isUserKazykurt () {
      return authorizationAPI.isRoleKazykurt()
    },
    isRoleErtys () {
      return authorizationAPI.isRoleErtys()
    },
    isRoleBatys () {
      return authorizationAPI.isRoleBatys()
    },
    isRoleVagonnik () {
      return authorizationAPI.isRoleVagonnik()
    },
    onCompanyChange (company) {
      this.selectedDocument = null
      this.selectedFormat = 'pdf'
      this.documents = getDocumentsList(company) || []
    },

    async download () {
      try {
        this.loading = true

        const [fromDate, toDate] = this.period

        const company = this.companies.find(
          item => item.station === this.selectedCompany
        )

        const apiMethod = this.selectedFormat === 'pdf'
          ? blockchainApi.downloadPrintFormsPdf
          : blockchainApi.downloadPrintForms

        const response = await apiMethod({
          fromDate: `${fromDate} 00:00:00`,
          toDate: `${toDate} 23:59:59`,
          bin: company.bin,
          docType: this.selectedDocument.key.split(',')[0]
        })

        let fileName = `${fromDate}-${toDate}.zip`

        const disposition = response.headers['content-disposition']
        const match = disposition && disposition.match(/filename="?([^"]+)"?/)

        if (match) {
          fileName = decodeURIComponent(match[1])
        }

        const blob = new Blob([response.data])
        const url = URL.createObjectURL(blob)

        const a = document.createElement('a')
        a.href = url
        a.download = fileName
        a.click()

        URL.revokeObjectURL(url)

        this.$message.success('Архив успешно скачан')
      } catch (e) {
        this.$message.error('Ошибка скачивания архива')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.print-forms-page {
  max-width: 1200px;
  margin: 20px auto;
}

.page-title {
  margin-bottom: 20px;
}

.documents-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}

.document-card {
  height: 80px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 16px;
  transition: all .2s;
}

.document-card:hover {
  border-color: #409eff;
}

.document-card.active {
  border-color: #409eff;
  background: #ecf5ff;
}

.document-card i {
  font-size: 20px;
  color: #409eff;
}

.document-card span {
  font-size: 14px;
  line-height: 18px;
}

.actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>
